import {
  IMobileDealerSelectTab,
  MobileDealerSelectTab,
} from '@/components/sections/dealer';
import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';
import { Grid } from '@/components/shared/layout/grid';

interface DealerResultMobileSelectTabProps {
  tabs: IMobileDealerSelectTab[];
  tab: MobileDealerSelectTab;
  onSelectTab: (tab: MobileDealerSelectTab) => void;
}

export const DealerResultMobileSelectTab: React.FunctionComponent<
  DealerResultMobileSelectTabProps
> = (props: DealerResultMobileSelectTabProps) => {
  return (
    <Grid
      templateColumns={2}
      css={{
        cursor: 'pointer',
        position: 'relative',
        borderBottom: '2px solid $gray300',
        '@lg': {
          display: 'none',
        },
      }}
    >
      {props.tabs.map((tab, index) => (
        <Box
          key={`mobileDealerSelectTab${index}`}
          position="relative"
          backgroundColor={props.tab === tab.key ? 'white' : 'gray200'}
          paddingX={{ '@initial': '6', '@sm': '7' }}
          paddingY={{ '@initial': '3', '@sm': '4' }}
          css={{
            '&::before': {
              content: '""',
              position: 'absolute',
              left: '0',
              top: '100%',
              bc: '$primary',
              width: '100%',
              height: '2px',
              transform: props.tab === tab.key ? 'scaleY(1)' : 'scaleY(0)',
              transition: 'transform .2s ease',
            },
          }}
          onClick={() => props.onSelectTab(tab.key)}
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            gap="2"
            css={{
              color: props.tab === tab.key ? '$primary' : '$gray700',
            }}
          >
            <Icon icon={tab.icon} color="icon-current" />
            <Text
              as="p"
              font="bold"
              variant="text-current"
              css={{ marginBottom: -2 }}
            >
              {tab.label}
            </Text>
          </Flex>
        </Box>
      ))}
    </Grid>
  );
};

DealerResultMobileSelectTab.displayName = 'SectionDealerResultMobileSelectTab';
